module.exports = __webpack_public_path__ + "SC05.a5530527.json";